// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.check {
  width: 200px;
  display: flex;
  justify-content: space-between;
  font-weight: 600;
  color: #0A4064;
  transition: 0.34s ease;
}
.check:hover {
  color: #00AEEF;
}

.check input[type=radio] {
  opacity: 0;
}

.check input[type=checkbox] {
  opacity: 0;
}

.check label:before {
  content: "";
  display: inline-block;
  position: relative;
  top: 3px;
  margin-right: 10px;
  width: 18px;
  height: 18px;
  border-radius: 10px;
  border: 2px solid #0A4064;
  background-color: transparent;
}

.check input[type=radio]:checked + label:before {
  position: relative;
  border: 2px solid #0A4064;
  border-radius: 10px;
  width: 18px;
  height: 18px;
  top: 4px;
  content: " ";
  display: inline-block;
  background-color: #0A4064;
}

.check input[type=checkbox]:checked + label:before {
  position: relative;
  border: 2px solid #0A4064;
  border-radius: 10px;
  width: 18px;
  height: 18px;
  top: 4px;
  content: " ";
  display: inline-block;
  background-color: #0A4064;
}

.disabled {
  opacity: 30%;
}

.check-small-label {
  justify-content: space-between;
  font-weight: 500;
  font-size: 0.85em;
  color: #0A4064;
  transition: 0.34s ease;
}
.check-small-label:hover {
  color: #00AEEF;
}

.check-small-label input[type=radio] {
  opacity: 0;
  margin-left: -13px;
}

.check-small-label input[type=checkbox] {
  opacity: 0;
  margin-left: -13px;
}

.check-small-label label:before {
  content: "";
  display: inline-block;
  position: relative;
  top: 3px;
  margin-right: 10px;
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 2px solid #0A4064;
  background-color: transparent;
}

.check-small-label input[type=radio]:checked + label:before {
  position: relative;
  border: 2px solid #0A4064;
  border-radius: 4px;
  width: 18px;
  height: 18px;
  color: white;
  font-size: 1.25rem;
  content: "✓"; /* css checkmark */
  display: inline-block;
  background-color: #0A4064;
  text-align: center; /* Ensures the checkmark is centered horizontally */
  line-height: 18px; /* Matches the height to vertically center the checkmark */
  top: 3px; /* Reset the top property */
}

.check-small-label input[type=checkbox]:checked + label:before {
  position: relative;
  border: 2px solid #0A4064;
  border-radius: 4px;
  width: 18px;
  height: 18px;
  color: white;
  font-size: 1.25rem;
  content: "✓"; /* css checkmark */
  display: inline-block;
  background-color: #0A4064;
  text-align: center; /* Ensures the checkmark is centered horizontally */
  line-height: 18px; /* Matches the height to vertically center the checkmark */
  top: 3px; /* Reset the top property */
}

.check-small-label input[type=checkbox]:focus + label {
  background: rgba(23, 134, 219, 0.2);
}

.check-small-label input[type=radio]:focus + label {
  background: rgba(23, 134, 219, 0.2);
}

.check-small-line-height {
  margin-top: -5px;
}`, "",{"version":3,"sources":["webpack://./src/styles/CheckboxButton.scss","webpack://./src/styles/global/Colors.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;EAGI,sBAAA;ADEJ;;ACLA;;;EAGI,sBAAA;ADQJ;;AARA;EACI,YAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,cCOM;EDNN,sBAAA;AAWJ;AAVI;EACI,cCLM;ADiBd;;AATA;EACI,UAAA;AAYJ;;AAVA;EACI,UAAA;AAaJ;;AAXA;EACI,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,6BAAA;AAcJ;;AAZA;EACI,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,YAAA;EACA,qBAAA;EACA,yBC1BM;ADyCV;;AAbA;EACI,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,YAAA;EACA,qBAAA;EACA,yBCrCM;ADqDV;;AAdA;EACI,YAAA;AAiBJ;;AAZA;EACI,8BAAA;EACA,gBAAA;EACA,iBAAA;EACA,cCjDM;EDkDN,sBAAA;AAeJ;AAdI;EACI,cC7DM;AD6Ed;;AAbA;EACI,UAAA;EACA,kBAAA;AAgBJ;;AAdA;EACI,UAAA;EACA,kBAAA;AAiBJ;;AAdA;EACI,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,6BAAA;AAiBJ;;AAfA;EACI,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA,EAAA,kBAAA;EACA,qBAAA;EACA,yBCtFM;EDuFN,kBAAA,EAAA,mDAAA;EACA,iBAAA,EAAA,0DAAA;EACA,QAAA,EAAA,2BAAA;AAkBJ;;AAhBA;EACI,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA,EAAA,kBAAA;EACA,qBAAA;EACA,yBCrGM;EDsGN,kBAAA,EAAA,mDAAA;EACA,iBAAA,EAAA,0DAAA;EACA,QAAA,EAAA,2BAAA;AAmBJ;;AAhBA;EACI,mCAAA;AAmBJ;;AAjBA;EACI,mCAAA;AAoBJ;;AAlBA;EACI,gBAAA;AAqBJ","sourcesContent":["@import \"./global/Colors\";\n@import \"./global/globalMixins\";\n\n.check {\n    width: 200px;\n    display: flex;\n    justify-content: space-between;\n    font-weight: 600;\n    color: $dk-blue;\n    transition: 0.34s ease;\n    &:hover {\n        color: $information;\n    }\n}\n.check input[type=radio] {\n    opacity: 0;\n}\n.check input[type=checkbox] {\n    opacity: 0;\n}\n.check label:before {\n    content: \"\";\n    display: inline-block;\n    position: relative;\n    top: 3px;\n    margin-right: 10px;\n    width: 18px;\n    height: 18px;\n    border-radius: 10px;\n    border: 2px solid $dk-blue;\n    background-color: transparent;\n}\n.check input[type=radio]:checked+label:before {\n    position: relative;\n    border: 2px solid $dk-blue;\n    border-radius: 10px;\n    width: 18px;\n    height: 18px;\n    top: 4px;\n    content: \" \";\n    display: inline-block;\n    background-color: $dk-blue;\n}\n.check input[type=checkbox]:checked+label:before {\n    position: relative;\n    border: 2px solid $dk-blue;\n    border-radius: 10px;\n    width: 18px;\n    height: 18px;\n    top: 4px;\n    content: \" \";\n    display: inline-block;\n    background-color: $dk-blue;\n}\n.disabled {\n    opacity: 30%;\n}\n//////////////////////////////////////////////////////////////////////////////////////////\n// alternative rules for using a \"small inline font\" while using a RadioButton\n//////////////////////////////////////////////////////////////////////////////////////////\n.check-small-label {\n    justify-content: space-between;\n    font-weight: 500;\n    font-size: .85em;\n    color: $dk-blue;\n    transition: 0.34s ease;\n    &:hover {\n        color: $information;\n    }\n}\n.check-small-label input[type=radio] { // hide the radio input\n    opacity: 0;\n    margin-left: -13px;\n}\n.check-small-label input[type=checkbox] { // hide the checkbox input\n    opacity: 0 ;\n    margin-left: -13px;\n}\n\n.check-small-label label:before {\n    content: \"\";\n    display: inline-block;\n    position: relative;\n    top: 3px;;\n    margin-right: 10px;\n    width: 18px;\n    height: 18px;\n    border-radius: 4px;\n    border: 2px solid $dk-blue;\n    background-color: transparent;\n}\n.check-small-label input[type=radio]:checked+label:before {\n    position: relative;\n    border: 2px solid $dk-blue;\n    border-radius: 4px;\n    width: 18px;\n    height: 18px;\n    color: white;\n    font-size: 1.25rem;\n    content: \"\\2713\"; /* css checkmark */\n    display: inline-block;\n    background-color: $dk-blue;\n    text-align: center; /* Ensures the checkmark is centered horizontally */\n    line-height: 18px; /* Matches the height to vertically center the checkmark */\n    top: 3px; /* Reset the top property */\n}\n.check-small-label input[type=checkbox]:checked + label:before {\n    position: relative;\n    border: 2px solid $dk-blue;\n    border-radius: 4px;\n    width: 18px;\n    height: 18px;\n    color: white;\n    font-size: 1.25rem;\n    content: \"\\2713\"; /* css checkmark */\n    display: inline-block;\n    background-color: $dk-blue;\n    text-align: center; /* Ensures the checkmark is centered horizontally */\n    line-height: 18px; /* Matches the height to vertically center the checkmark */\n    top: 3px; /* Reset the top property */\n}\n\n.check-small-label input[type=checkbox]:focus + label {\n    background: rgba(23, 134, 219, .2);\n}\n.check-small-label input[type=radio]:focus + label {\n    background: rgba(23, 134, 219, .2);\n}\n.check-small-line-height {\n    margin-top: -5px;\n}\n","*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n$lt-blue: #7DB7CC;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n$DCSD-logo-green: #84ae30;\n$dashboard-blue: #0d6efd;\n$dk-blue: #0A4064;\n$important: #FEBF31;\n$highlight: #FDF9D0;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$grey5: #333;\n$pale-blue: #C0DEF0;\n$pearl-dk-blue: #0762a7;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n$teal-logo: #46A8B0;\n\n$pale-blue-green: #9acdd2;\n$pale-blue-green-outline: #75c2c9;\n\n$pale-purple: #bca0d3;\n$pale-purple-outline: #946eb4;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
